export class AppConfig {
    Version: string;
    UrlBase: string;
    LoginRedirectUrl: string;
    TenantName: string;
  }
  
  export default AppConfig